import { Component, OnInit, Inject } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
  MatSnackBar
} from '@angular/material';
import { AdminService } from '../../../../../../../services/admin/admin.service';
import { TdLoadingService } from '@covalent/core';
import { ConfirmationDialogComponent } from './dialogs/confirmation-dialog/confirmation-dialog.component';
import { AddEmployeeDialogComponent } from './dialogs/add-employee-dialog/add-employee-dialog.component';

@Component({
  selector: 'app-review-results-dialog',
  templateUrl: './review-results-dialog.component.html',
  styleUrls: ['./review-results-dialog.component.scss']
})
export class ReviewResultsDialogComponent implements OnInit {
  tasks: any;
  mayorComments: any = [];
  comment: string = '';
  addExecuteButtonShow: boolean = true;
  constructor(
    public dialogRef: MatDialogRef<ReviewResultsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _adminService: AdminService,
    private _loadingService: TdLoadingService,
    private _matDialog: MatDialog,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.getTasks(this.data.petition.id);
  }
  closeDialog() {
    this.dialogRef.close();
  }
  getTasks(ideaId: number) {
    this._loadingService.register();
    this._adminService.getTasks(ideaId).subscribe(
      (res) => {
        this._loadingService.resolve();
        res.forEach((task: any) => {
          task.children = res.filter(
            (item: any) => item.parentEmployeeTaskId === task.id
          );
        });
        this.tasks = res.sort((a, b) => {
          return a.role === 'PT.SUPERVISE.READ' ? -1 : a.id - b.id;
        });
        if (this.tasks.length === 3) {
          this.addExecuteButtonShow = !!this.tasks.find(
            (task) => task.realisable === null
          );
        }
        this.getTaskFeedback(res[0].taskId);
      },
      (err) => {
        this._loadingService.resolve();
        this._snackBar.open('დაფიქსირდა შეცდომა', null, {
          duration: 2000,
          panelClass: 'red-snackbar',
          horizontalPosition: 'right',
          verticalPosition: 'top'
        });
      }
    );
  }
  getTaskFeedback(ideaId: number) {
    this._loadingService.register();
    this._adminService.getTaskFeedbacks(ideaId).subscribe(
      (res: any) => {
        this._loadingService.resolve();
        this.tasks.forEach((item) => {
          item.comments = res.filter(
            (feedback: any) => feedback.createdByEmployeeId == item.employeeId
          );
        });
        this.mayorComments = res.filter(
          (item) =>
            item.createdByEmployeeId == this.tasks[0].taskCreatedById &&
            item.targetEmployeeId === null
        );
      },
      (err) => {
        this._loadingService.resolve();
        this._snackBar.open('დაფიქსირდა შეცდომა', null, {
          duration: 2000,
          panelClass: 'red-snackbar',
          horizontalPosition: 'right',
          verticalPosition: 'top'
        });
      }
    );
  }
  get neededTasks() {
    this.tasks;
    return this.tasks.filter((task) => task.children.length);
  }
  getExecuteNeededTasks(task) {
    return this.tasks.filter((task) => task.role == 'PT.EXECUTE.READ');
  }
  countExecutors = () => {
    return (this.tasks || []).filter((e) => {
      return e.role == 'PT.EXECUTE.READ';
    }).length;
  };
  hasPosition = (item) => {
    //because realisable false is no answer true is yes answer and null is no action
    if (item.realisable === false || item.realisable) {
      return false;
    }
    if (item.children) {
      for (var i = 0, l = item.children.length; i < l; i++) {
        if (
          item.children[i].realisable == false &&
          item.children[i].realisable
        ) {
          return false;
        }
      }
    }
    return true;
  };
  isInStatusList = () => {
    var arr = [8, 13, -8, -13];
    return arr.indexOf(this.data.petition.statusId) > -1;
  };
  deleteExecutor(item, e) {
    const confirmationDialog = this._matDialog.open(
      ConfirmationDialogComponent,
      {
        width: '675px',
        data: {
          title: `დარწმუნებული ხართ, რომ გსურთ პასუხისმგებელი პირი ${item.employeeFullLame} წაშლოთ განხილვიდან?`
        }
      }
    );
    confirmationDialog.afterClosed().subscribe((res: boolean) => {
      if (res) {
        this._loadingService.register();
        this._adminService
          .deleteTaskExecutor(item.petitionId, item.employeeId)
          .subscribe(
            (res) => {
              this._loadingService.resolve();
              this._snackBar.open('პასუხისმგებელი პირი წაშლილია', null, {
                duration: 2000,
                panelClass: 'green-snackbar',
                horizontalPosition: 'left'
              });
              this.getTasks(this.data.petition.id);
            },
            (err) => {
              this._loadingService.resolve();
              this._snackBar.open('დაფიქსირდა შეცდომა', null, {
                duration: 2000,
                panelClass: 'red-snackbar',
                horizontalPosition: 'right',
                verticalPosition: 'top'
              });
            }
          );
      }
    });
  }
  addPeople(mode) {
    const dialogRef = this._matDialog.open(AddEmployeeDialogComponent, {
      width: '675px',
      data: {
        petition: this.data.petition,
        tasks: this.neededTasks,
        changeMode: mode
      }
    });
    dialogRef.afterClosed().subscribe((res) => {
      if (res && res.length) {
        this._snackBar.open(res, null, {
          duration: 2000,
          horizontalPosition: 'left',
          panelClass: 'green-snackbar'
        });
        this.getTasks(this.data.petition.id);
      }
    });
  }
  inPersonsList() {
    return this.tasks
      ? this.tasks.findIndex((e) => {
          return e.employeeTaskUserId === this.userId;
        }) > -1
      : false;
  }
  addFeedback() {
    this._loadingService.register();
    if (!this.comment) {
      return;
    } else {
      this._adminService
        .addTaskFeedbacks({
          petitionId: this.data.petition.id,
          commentary: this.comment
        })
        .subscribe(
          (res) => {
            this._loadingService.resolve();
            this.comment = '';
            this._snackBar.open('კომენტარი დაემატა', null, {
              duration: 2000,
              panelClass: 'green-snackbar',
              horizontalPosition: 'right',
              verticalPosition: 'top'
            });
            this.getTasks(this.data.petition.id);
          },
          (err) => {
            this._loadingService.resolve();
            this._snackBar.open('დაფიქსირდა შეცდომა', null, {
              duration: 2000,
              panelClass: 'red-snackbar',
              horizontalPosition: 'right',
              verticalPosition: 'top'
            });
          }
        );
    }
  }
  get userId() {
    return JSON.parse(localStorage.getItem('sessionData')).id;
  }
  get isMayor() {
    return this._adminService.isMayor;
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/components/admin/components/shared/petition-details/dialogs/review-results-dialog/review-results-dialog.component.ts